<template>
  <div class="hd-preview-box-tab">
    <div
      :class="['hd-preview-box-tab-item', activeIndex == index ? 'active' : '']"
      v-for="(item, index) in list"
      :key="index"
      @click="onClickChange(index)"
    >
      {{ item }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    defaultActive: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      activeIndex: 0,
    };
  },
  watch: {
    defaultActive: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.activeIndex = newVal;
        }
      },
      immediate: true,
    },
  },
  methods: {
    onClickChange(index) {
      console.log("index", index);
      this.activeIndex = index;
      this.$emit("change", index);
    },
  },
};
</script>
<style scoped lang="scss">
.hd-preview-box-tab {
  width: fit-content;
  height: 32px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #cbcfd6;
  display: flex;
  margin-top: 20px;
  .hd-preview-box-tab-item {
    height: 32px;
    padding: 6px 16px;
    font-size: 14px;
    color: #565960;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid #cbcfd6;
    cursor: pointer;
    &:first-child {
      border-left: none;
    }
  }
  .hd-preview-box-tab-item.active {
    color: #3159ff;
  }
}
</style>
